import { ReactNode } from 'react';

import { ActionBar } from '@dreryk/react-components';

type StatisticsPreviewActionBarProps = {
   readonly children: ReactNode;
};

export const StatisticsPreviewActionBar = (props: StatisticsPreviewActionBarProps): JSX.Element => {
   return (
      <ActionBar id='statistic-preview-action-bar' testId='StatisticsPreviewActionBar'>
         {props.children}
      </ActionBar>
   );
};

export enum StatisticsPreviewActionBarOrder {
   DownloadAsCsv,
   Print,
   GoToStatisticList,
}
